import React from 'react';
import '../styles/gemcard.css';

interface Gem {
  name: string;
  type: string;
  tags: string;
  description: string;
  effects: string[];
}

interface GemCardProps {
  gem: Gem;
  isExpanded: boolean;
  onToggleExpand: () => void;
}

export const GemCard: React.FC<GemCardProps> = ({ gem, isExpanded, onToggleExpand }) => {
  return (
    <div className={`gem-card ${isExpanded ? 'expanded' : ''}`} onClick={onToggleExpand}>
      <h3>{gem.name}</h3>
      {isExpanded && (
        <div className="gem-content">
          <div className="gem-type">{gem.type}</div>
          <p className="gem-description">{gem.description}</p>
          <div className="gem-tags">
            {gem.tags.split(', ').map((tag, index) => (
              <span key={index} className="gem-tag">{tag}</span>
            ))}
          </div>
          <div className="gem-effects">
            {gem.effects.map((effect, index) => (
              <div key={index} className="gem-effect">{effect}</div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}; 